<template>
  <div class="document-uploading full-size flex-vertical">
    <ModalWindow
      ref="deleteFileModalWindow"
      name="deleteFileModalWindow"
      header="Удаление элементов"
    >
      <div class="flex-vertical">
        <div class="delete-file-modal-window-text">
          Вы действительно хотите удалить это изображение?
        </div>
        <div class="delete-file-modal-window-buttons flex">
          <button @click="deleteFile(selectedFileIndex)">Удалить</button>
          <button @click="hideDeleteFileModalWindow" class="gray-btn">
            Отменить
          </button>
        </div>
      </div>
    </ModalWindow>
    <div class="document-uploading-header font-bold-24px">
      {{ title }}
    </div>
    <div class="flex full-size">

      <div v-if="files.length > 0" class="document-uploading-content-splited flex-vertical full-height">
        <div class="document-uploading-files">
          <div class="document-uploading-files-preview full-width flex">
            <div
              v-for="(file, index) in files"
              :key="index"
              class="file-preview-container flex-vertical"
            >
              <div 
                @click="showDeleteFileModalWindow(index)"
                class="delete-file-button flex">
                X
              </div>
              <div
                class="file-preview-image-container vld-parent"
                @click="showFileViewer(index)"
                :style="{ backgroundImage: `url(${file.data})` }">
                
                <loading :active.sync="file.isLoading" :is-full-page="false"></loading>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="fileViewerIsShowed"
           class="document-file-viewer flex-vertical full-size">
        <div class="document-file-viewer-header flex full-width">
          <div class="hide-file-viewer-button" @click="hideFileViewer">
            <img src="../../../public/icons/ArrowLeft.svg" />
          </div>
          <div class="delete-selected-file-button"
               @click="showDeleteFileModalWindow(selectedFileIndex)">
            <img src="../../../public/icons/Trash.svg" />
          </div>
        </div>
        <div class="document-file-viewer-img flex-vertical full-size">
          <img :src="displayedFileSrc" class="file-preview" @click="hideFileViewer"/>
        </div>
      </div>
      <div class="document-uploading-content flex-vertical full-height"
           v-bind:class="{ 'full-width': files.length === 0, 'document-uploading-content-splited': files.length > 0 }">
        <div class="document-uploading-slots">
          <div class="document-uploading-slot">
            <slot></slot>
          </div>
          <slot name="uploadingcomment"></slot>
        </div>
        <div class="dropbox flex">
          <input type="file"
                 multiple
                 ref="documentFiles"
                 id="documentFiles"
                 class="document-files full-size"
                 @change="saveUploadedFiles"/>

          <div class="flex-vertical">
            <div>
              Для загрузки кликните мышью<br />
              или перетащите файлы сюда
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="document-uploading-inputs flex">
      <button @click="openFileSelector">Загрузить</button>
      <button @click="selectNextStep">Далее</button>
    </div>
  </div>
</template>

<script>
import UploadingFormMixin from "../mixins/UploadingFormMixin.js";
import ModalWindow from "../common/ModalWindow.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: "UploadingForm",
  components: {
    ModalWindow,
    Loading
  },
  mixins: [UploadingFormMixin],
};
</script>

<style lang="scss" scoped>
@import "../../../src/styles/colors.scss";

.document-uploading {
  overflow: hidden;
  overflow-y: auto;
}

.document-uploading-header {
  margin-bottom: 25px;
  max-width: 840px;
}

.document-uploading-content {
  overflow: hidden;
}

.document-uploading-content-splited {
  @extend .document-uploading-content;
  width: 50%;
}

.document-uploading-inputs {
  justify-content: flex-end;
  margin-top: 5px;
  margin-right: 7px;

  button {
    margin-left: 5px;
    min-width: 160px;
  }
}

.document-uploading-files {
  flex-basis: 100%;
  height: calc(100% - 70px);
  margin-right: 20px;
}

.document-uploading-files-preview {
  overflow-y: hidden;
  height: 100%;
  flex-wrap: wrap;
}

.document-uploading-slots {
  margin-left: 10px;
}

.document-uploading-slot {
  width: 48%; 
  min-width: 300px;
}

.file-preview-container {
  margin-bottom: 10px;
  align-items: flex-end;
  flex-basis: 50%;
}

.file-preview-image-container {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-position-y: top;
}

.delete-file-button {
  width: 28px;
  height: 28px;
  min-width: 28px;
  min-height: 28px;
  border-radius: 50%;
  border: 2px solid $main-color;
  color: $main-color;
  justify-content: center;
  align-items: center;
  font-family: IBMPlexSans-bold;
  cursor: pointer;
  transition: background-color 0.5s ease;
  margin-right: 5px;
}

.delete-file-button:hover {
  color: $white-color;
  background-color: $main-color;
}

.file-preview {
  padding: 5px;
  height: calc(100% - 28px);
  object-fit: contain;
}

.content-title {
  margin-bottom: 24px;
}

.dropbox {
  position: relative;
  margin-top: 5px;
  outline: 2px dashed grey;
  outline-offset: -10px;
  background: $white-color;
  color: dimgray;
  min-height: 110px;
  min-width: 100px;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-basis: 100%;
}

.dropbox:hover {
  background: #f5fbfb;
}

.dropbox div {
  font-family: IBMPlexSans-regular;
  text-align: center;
  display: flex;
  align-self: center;
}

.document-files {
  opacity: 0;
  position: absolute;
  cursor: pointer;
}

.delete-file-modal-window-text {
  margin-bottom: 84px;
}

.delete-file-modal-window-buttons {
  align-items: flex-start;

  button {
    margin-right: 8px;
  }
}


.document-file-viewer {
  position: fixed;
  top: 0px;
  left: 0px;
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #000000;
  z-index: 1000;
}

.document-file-viewer-header {
  padding: 15px 15px 10px;
  width: 80px;
  height: 80px;
  min-width: 80px;
  min-height: 80px;
}

.hide-file-viewer-button {
  width: 100%;
  cursor: pointer;
  img {
    width: 60px;
  }
}

.delete-selected-file-button {
  width: 100%;
  cursor: pointer;
  margin-left: 30px;
  img {
    width: 60px;
  }
}

.document-file-viewer-img {
  justify-content: center;
  padding-bottom: 60px;
  cursor: pointer;
}
</style>